import { render, staticRenderFns } from "./PostDetailFile.vue?vue&type=template&id=1ad88b57&scoped=true"
import script from "./PostDetailFile.vue?vue&type=script&lang=js"
export * from "./PostDetailFile.vue?vue&type=script&lang=js"
import style0 from "./PostDetailFile.vue?vue&type=style&index=0&id=1ad88b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad88b57",
  null
  
)

export default component.exports